import CryptoJS from 'crypto-js';
import FLUJOS_CONFIG from '../config/flujosConfig';

const SECRET_KEY = 'clave_flujo_eme2024';

export const resolverFlujoEncriptado = (cadena) => {
  /* const DEFAULT_FLUJO = {
    clave: 'default',
    tipo: 'odontrut',
    valor: '82',
    descripcion: 'Flujo por defecto (producción)',
    sucursalesPermitidas: [1,2,5,8,9]
  }; */

  const DEFAULT_FLUJO = {
    clave: 'default',
    tipo: 'odontrut',
    valor: '10276218',
    descripcion: 'Flujo por defecto (Landing)',
    sucursalesPermitidas: [1,2]
  };

  try {
    const bytes = CryptoJS.AES.decrypt(cadena, SECRET_KEY);
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8);
    let claveFlujo = decryptedText;    
    const match = decryptedText.match(/^claveFlujo=(.+)$/);

    if (match) claveFlujo = match[1];

        const definicion = FLUJOS_CONFIG[claveFlujo];

    if (!definicion) return DEFAULT_FLUJO;

    return {
    clave: claveFlujo,
    tipo: definicion.tipo,
    valor: definicion.valor,
    descripcion: definicion.descripcion,
    sucursalesPermitidas: definicion.sucursalesPermitidas || []
    };
  } catch (error) {
    console.warn("❌ Error desencriptando, usando flujo por defecto.");
    return DEFAULT_FLUJO;
  }
};
